<template>
  <div class="concern-companies-container">
    <div class="row concern-companies-content">
      <div class="concern-companies-content-right">
        <!-- <real-time-data :data="realTimeData" :year="year" :month="month" :date="date" :day="day" :hour="hour" :minute="minute" :second="second"></real-time-data> -->
      </div>
    </div>
    <div class="concern-industry-news-list">
      <header-second-tabs :tabs="newsListTabs" @change="onNewsListTabChange">
        <div v-if="newsListSelectedOptionTab === '中信一级行业' && industryCount > 0">
          <SnDatePicker ref="SnDatePicker" class="sn-date-picker" @timeChange="timeChange"></SnDatePicker>
          <el-select class="concern-industry-news-list-select set-vertical-align" @change="onMonitorIndustryNewsListGroupChange"  v-model="newsListOption" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button @click="onShowIndustryFilter" class="concern-industry-news-list-filter-btn set-vertical-align">
            <img src="../../assets/img/show-filter-icon.svg" class="concern-industry-news-list-filter-btn-img icon" alt="">
            事件情感筛选
          </el-button>
        </div>
        <div v-if="newsListSelectedOptionTab === '市场主题' && themeCount > 0">
          <SnDatePicker ref="SnDatePicker" class="sn-date-picker" @timeChange="timeChange"></SnDatePicker>
          <el-select class="concern-industry-news-list-select set-vertical-align" @change="onMonitorThemeNewsListGroupChange"  v-model="themeNewsListOption" placeholder="请选择">
            <el-option
              v-for="item in themeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button @click="onShowThemeFilter" class="concern-industry-news-list-filter-btn set-vertical-align">
            <img src="../../assets/img/show-filter-icon.svg" class="concern-industry-news-list-filter-btn-img icon" alt="">
            事件情感筛选
          </el-button>
        </div>
      </header-second-tabs>
      <ConcernIndustryNewsList v-if="newsListSelectedOptionTab === '中信一级行业'" ref="concernIndustry" :industryCount="industryCount" :dateRangeData="dateRange" :industryTagData="industryData"></ConcernIndustryNewsList>
      <ConcernThemeNewsList v-if="newsListSelectedOptionTab === '市场主题'" ref="concernTheme" :themeCount="themeCount" :dateRangeData="dateRange" :themeTagData="themeData"></ConcernThemeNewsList>
    </div>
  </div>
</template>

<script>
import RealTimeData from '@/components/concern/RealTimeData';
import ConcernIndustryNewsList from '@/components/concern/ConcernIndustryNewsList';
import ConcernThemeNewsList from '@/components/concern/ConcernThemeNewsList';
import HeaderSecondTabs from '@/components/common/HeaderSecondTabs';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import RecommendFocusNewsItem from '@/components/recommend/RecommendFocusNewsItem';
import ConcernIndustryNewsListFilter from '@/components/news-monitor/ConcernIndustryNewsListFilter';
import IndustryNewsListFilterPanel from '@/components/news-monitor/IndustryNewsListFilterPanel';
import IndustryNewsListItem from '@/components/news-monitor/IndustryNewsListItem';
import SnHeader from '@/components/common/SnHeader';
import SnDatePicker from '@/components/common/SnDatePicker';

export default {
  data() {
    return {
      newsListTabs: ['中信一级行业', '市场主题'],
      newsListSelectedOptionTab: '中信一级行业',
      username: '',
      realTimeData: [],
      newsListOption: '全部',
      options: [],
      themeNewsListOption: '全部',
      themeOptions: [],
      industryNewsListFilters: null,
      industryData: [],
      dateRange: [],
      themeData: []
    };
  },
  props: ['industryCount', 'themeCount', 'year', 'month', 'date', 'day', 'hour', 'minute', 'second'],
  methods: {
    onMonitorThemeNewsListGroupChange(res) {
      this.themeData = res === '全部' ? [] : [res];
    },
    timeChange(date) {
      if (!date) {
        this.dateRange = [];
      } else {
        this.dateRange = date;
      }
    },
    onShowIndustryFilter() {
      this.$refs.concernIndustry.onShowIndustryFilter();
    },
    onShowThemeFilter() {
      this.$refs.concernTheme.onShowIndustryFilter();
    },
    onMonitorIndustryNewsListGroupChange(res) {
      this.industryData = res === '全部' ? [] : [res];
    },
    onNewsListTabChange({ item }) {
      this.newsListSelectedOptionTab = item;
      if (this.$refs.SnDatePicker) {
        this.$refs.SnDatePicker.initializeTime();
      }
      this.dateRange = [];
      if (this.newsListSelectedOptionTab === '中信一级行业') {
        this.industryData = [];
        this.newsListOption = '全部';
      } else if (this.newsListSelectedOptionTab === '市场主题') {
        this.themeData = [];
        this.themeNewsListOption = '全部';
      }
    },
    getMonitorIndustryCount() {
      QuestionQuery.getMonitorIndustryCount(this.username).then(res => {
        this.realTimeData = [
          {
            title: '舆情数量/条',
            count: res.total
          },
          {
            title: '负面舆情/条',
            count: res.negative
          },
          {
            title: '正面舆情/条',
            count: res.positive
          },
          {
            title: '中性舆情',
            count: res.neutral
          }
        ];
      });
    },
    getMonitorThemeTag() {
      QuestionQuery.getMonitorThemeTagList(this.username).then(res => {
        this.themeOptions = res.map(item => {
          return {
            label: item.theme,
            value: item.theme
          };
        });
        this.themeOptions.unshift({
          label: '全部',
          value: '全部'
        });
        const emotional = [
          {
            id: '正面',
            name: '正面'
          },
          {
            id: '负面',
            name: '负面'
          },
          {
            id: '中性',
            name: '中性'
          }
        ];
        /* eslint-disable */
        this.themeNewsListFilters = {
          emotional: emotional
        };
      });
    },
    getMonitorIndustryTag() {
      QuestionQuery.getMonitorIndustryTag(this.username).then(res => {
        this.options = res.industry.map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
        this.options.unshift({ label: '全部', value: '全部' });
        const emotional = [
          {
            id: '正面',
            name: '正面'
          },
          {
            id: '负面',
            name: '负面'
          },
          {
            id: '中性',
            name: '中性'
          }
        ];
        /* eslint-disable */
        this.industryNewsListFilters = {
          event: res.event,
          emotional: emotional
        };
      });
    }
  },
  components: {
    RealTimeData,
    RecommendFocusNewsItem,
    HeaderSecondTabs,
    ConcernIndustryNewsListFilter,
    IndustryNewsListFilterPanel,
    IndustryNewsListItem,
    SnHeader,
    SnDatePicker,
    ConcernIndustryNewsList,
    ConcernThemeNewsList
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getMonitorIndustryCount();
    this.getMonitorIndustryTag();
    this.getMonitorThemeTag();
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
  height: 16px;
}
.concern-companies-container {
  width: 100%;
  .concern-industry-news-list-item {
    min-height: 800px;
  }
  .concern-companies-content {
    width: 100%;
    .concern-companies-content-left {
      position: relative;
      margin-right: 10px;
      width: 780px;
      height: 470px;
      background-color: #ffffff;
      .important-news-unread-message {
        position: absolute;
        top: 52px;
        left: 50%;
        transform: translateX(-50%);
        padding: 0 12px;
        height: 17px;
        background-color: #636772;
        border-radius: 2px;
        z-index: 1;
        cursor: pointer;
        .important-news-unread-count {
          margin-right: 4px;
          color: #ffffff;
          font-size: 12px;
          cursor: pointer;
        }
      }
      .checkout-title {
        margin-left: 4px;
        color: #464d6c;
        font-size: 14px;
      }
      .recommend-focus-news-list {
        height: 426px;
        overflow: auto;
        padding: 0 24px;
      }
    }
    .concern-companies-content-right {
      width: 100%;
      &-industry-theme {
        margin-top: 10px;
        width: 420px;
        height: 342px;
        background-color: #ffffff;
      }
    }
  }
  .concern-industry-news-list {
    margin-top: 10px;
    background-color: #ffffff;
    width: 100%;
    .sn-date-picker {
      margin-right: 10px;
    }
    &-select {
      width: 100px;
    }
    &-filter-btn {
      margin-left: 10px;
      height: 26px;
      width: 128px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #464d6c;
      background-color: #f7f8fc;
      font-weight: 400;
      &:hover {
        color: #464d6c;
        background-color: #eaeaed;
      }
      &:focus {
        color: #464d6c;
        background-color: #eaeaed;
      }
      &:active {
        color: #464d6c;
        background-color: #eaeaed;
      }
      &-img {
        margin-bottom: -3px;
      }
    }
    &-content {
      padding: 0 24px 18px;
      background-color: #ffffff;
      .filter-tag {
        position: relative;
        margin: 16px 0 0;
        width: 100%;
        background-color: #f7f8fc;
      }
    }
    .loading {
      padding: 12px 0;
      margin: 0 auto;
      height: 10px;
      width: 772px;
      color: #666666;
      text-align: center;
    }
  }
}
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 10px;
  width: 772px;
  color: #666666;
  text-align: center;
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none !important;
  border-radius: 2px;
  color: #464d6c;
  background-color: #f7f8fc !important;
  font-size: 14px;
  &:hover {
    background-color: #eaebef !important;
  }
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}
</style>
